import { createContext, useContext, type ReactNode } from 'react'

/** Per-instance display fields. Groups share slug `'g'`, so these can't live on AppModule. */
export interface InstanceDisplay {
  icon: ReactNode
  description: string
}

const InstanceDisplayContext = createContext<ReadonlyMap<string, InstanceDisplay>>(new Map())

export const InstanceDisplayProvider = InstanceDisplayContext.Provider

export function useInstanceDisplayMap(): ReadonlyMap<string, InstanceDisplay> {
  return useContext(InstanceDisplayContext)
}

export function useInstanceDisplay(instanceId: string): InstanceDisplay | undefined {
  return useContext(InstanceDisplayContext).get(instanceId)
}
